import { render, staticRenderFns } from "./appearance.vue?vue&type=template&id=5e4e7284"
import script from "./appearance.vue?vue&type=script&lang=js"
export * from "./appearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports